export const ROUTES = {
  APPROVAL: '/approval',
  APPROVED: '/approved',
  CANCELLED: '/cancelled',
  DAMAGE_REPORT: '/damage-report',
  HOME: '',
  PENDING: '/pending',
  PROFILE: '/profile',
  WHAT_HAPPENS: '/what-happens',
};

export const BASE_ROUTE = '/handshake';
